import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, hasAdminRole, startSessionRenewal } from '../utils/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  useEffect(() => {
    if (isAuthenticated()) {
      startSessionRenewal();
    }
  }, []);

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has Admin role
  if (!hasAdminRole()) {
    return <Navigate to="/error?message=Access denied. Admin role required." replace />;
  }

  return <>{children}</>;
}
